import { Box, Card, Typography } from "@mui/material";
import Logo from '../../assets/images/logo.svg';
import LoginForm from "./login.form";

const BRAND_BARS = [
    { height: 48, color: '#00D1FF' },
    { height: 64, color: '#00FFA3' },
    { height: 36, color: '#FF4F4F' },
    { height: 72, color: '#FFD700' },
    { height: 52, color: '#00D1FF' },
    { height: 40, color: '#00FFA3' },
];

export default function Login() {
    return (
        <Box sx={{ display: 'flex', minHeight: '100vh', bgcolor: 'background.default' }}>

                {/* Left brand panel — hidden on mobile */}
                <Box
                    sx={{
                        display: { xs: 'none', md: 'flex' },
                        flex: '0 0 45%',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        bgcolor: 'background.paper',
                        borderRight: '1px solid rgba(255,215,0,0.12)',
                        position: 'relative',
                        overflow: 'hidden',
                        backgroundImage: 'radial-gradient(rgba(255,215,0,0.06) 1px, transparent 1px)',
                        backgroundSize: '28px 28px',
                        px: 6,
                    }}
                >
                    {/* Glow orb */}
                    <Box
                        sx={{
                            position: 'absolute',
                            width: 320,
                            height: 320,
                            borderRadius: '50%',
                            background: 'radial-gradient(circle, rgba(255,215,0,0.08) 0%, transparent 70%)',
                            top: '30%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            pointerEvents: 'none',
                        }}
                    />

                    <img src={Logo} width="130" height="130" alt="CryptoPortfolio logo" />

                    <Typography
                        variant="h4"
                        fontWeight={700}
                        sx={{ mt: 3, color: 'text.primary', letterSpacing: '-0.5px', textAlign: 'center' }}
                    >
                        Crypto Portfolio
                    </Typography>

                    <Typography
                        variant="body1"
                        sx={{ mt: 1.5, color: 'text.secondary', textAlign: 'center', maxWidth: 280, lineHeight: 1.7 }}
                    >
                        Acompanha o teu portfolio.<br />Controla o teu futuro.
                    </Typography>

                    {/* Decorative bar chart */}
                    <Box sx={{ display: 'flex', alignItems: 'flex-end', gap: 1.5, mt: 5 }}>
                        {BRAND_BARS.map((bar, i) => (
                            <Box
                                key={i}
                                sx={{
                                    width: 14,
                                    height: bar.height,
                                    bgcolor: bar.color,
                                    borderRadius: '4px 4px 0 0',
                                    opacity: 0.7,
                                }}
                            />
                        ))}
                    </Box>
                </Box>

                {/* Right form panel */}
                <Box
                    sx={{
                        flex: 1,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        p: { xs: 2, sm: 4 },
                    }}
                >
                    <Card
                        sx={{
                            maxWidth: 420,
                            width: '100%',
                            p: { xs: 3, sm: 4 },
                            background: 'rgba(255,255,255,0.04)',
                            backdropFilter: 'blur(20px)',
                            border: '1px solid rgba(255,215,0,0.15)',
                            borderRadius: 3,
                            boxShadow: '0 8px 40px rgba(0,0,0,0.6)',
                        }}
                    >
                        {/* Mobile: logo inside card */}
                        <Box sx={{ display: { xs: 'flex', md: 'none' }, justifyContent: 'center', mb: 3 }}>
                            <img src={Logo} width="72" height="72" alt="CryptoPortfolio logo" />
                        </Box>

                        <Typography variant="h5" fontWeight={700} sx={{ color: 'text.primary' }}>
                            Bem-vindo de volta
                        </Typography>
                        <Typography variant="body2" sx={{ mt: 0.5, mb: 3, color: 'text.secondary' }}>
                            Introduz as tuas credenciais para continuar
                        </Typography>

                        <LoginForm />
                    </Card>
                </Box>

            </Box>
    );
}
